import { Box, Fade, Modal, useTheme } from '@mui/material';
import { ThemeMode } from 'config';
import { FC } from 'react';
import { ReactNode } from 'react';

interface AppModalProps {
    children: ReactNode;
    modalIsOpen: boolean;
    handleModalClose: () => void;
}

export const AppFormModal: FC<AppModalProps> = ({ children, modalIsOpen, handleModalClose }) => {
    const { palette } = useTheme();
    const backgroundColor = palette.mode === ThemeMode.DARK ? '#212946' : 'white';

    return (
        <Box>
            <Modal
                open={modalIsOpen}
                onClose={handleModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Fade in={modalIsOpen}>
                    <Box
                        sx={{ backgroundColor: backgroundColor }}
                        className="absolute top-1/2 left-1/2
              transform -translate-x-1/2 -translate-y-1/2 
              w-7/12 rounded-md shadow-lg p-8 max-h-[80vh] overflow-y-auto"
                    >
                        {children}
                    </Box>
                </Fade>
            </Modal>
        </Box>
    );
};
